import Deals from '../components/Deals'


export default Deals;